export default "__VITE_ASSET__CFYZ2xP___"